import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import api from '../api';

export default function SetupPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    if (password.length < 6) { setError('Password must be at least 6 characters.'); return; }
    setLoading(true);
    try {
      const res = await api.post('/auth/setup', { email, password });
      const { token, user, brand } = res.data;
      localStorage.setItem('qp_token', token);
      localStorage.setItem('qp_user', JSON.stringify(user));
      localStorage.setItem('qp_brand', JSON.stringify(brand));
      setDone(true);
      setTimeout(() => navigate('/dashboard'), 1500);
    } catch (err) {
      const detail = err.response?.data?.detail;
      const status = err.response?.status;
      if (detail) {
        setError(detail);
      } else if (status) {
        setError(`Server error (${status}). Please try again or contact support.`);
      } else {
        setError('Could not reach the server. Please check your connection and try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#F5F8FC', display: 'flex', flexDirection: 'column' }}>
      <div style={{ background: 'white', borderBottom: '1px solid #DDE7F1', padding: '16px 0', display: 'flex', justifyContent: 'center' }}>
        <img src="/logo.svg" alt="Quoteplicity" style={{ height: '32px' }} />
      </div>

      <div style={{ flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '80px', padding: '80px 16px 40px' }}>
        <div className="portal-card" style={{ width: '100%', maxWidth: '440px', padding: '32px' }}>
          <h2 style={{ fontSize: '22px', fontWeight: '700', textAlign: 'center', marginBottom: '8px', color: '#0F172A' }}>
            Create Your Account
          </h2>
          <p style={{ textAlign: 'center', color: '#64748B', fontSize: '14px', marginBottom: '24px' }}>
            First-time setup — creates the admin account for this portal.
          </p>

          {done ? (
            <div className="alert-success" style={{ textAlign: 'center' }}>
              <i className="fas fa-check-circle mr-2"></i>Account created! Redirecting to dashboard...
            </div>
          ) : (
            <>
              {error && (
                <div className="alert-error" style={{ marginBottom: '16px' }}>
                  <i className="fas fa-exclamation-circle mr-2"></i>{error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', marginBottom: '6px' }}>Email</label>
                  <input type="email" className="input-field" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@youragency.com" required />
                </div>
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', marginBottom: '6px' }}>Password</label>
                  <input type="password" className="input-field" value={password} onChange={e => setPassword(e.target.value)} placeholder="At least 6 characters" required />
                </div>
                <div style={{ marginBottom: '24px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', marginBottom: '6px' }}>Confirm Password</label>
                  <input type="password" className="input-field" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat password" required />
                </div>
                <button type="submit" className="btn-primary" style={{ width: '100%', height: '44px', fontSize: '15px' }} disabled={loading}>
                  {loading ? <><i className="fas fa-spinner fa-spin mr-2"></i>Creating...</> : 'Create Account'}
                </button>
              </form>

              <div style={{ textAlign: 'center', marginTop: '16px' }}>
                <Link to="/login" style={{ fontSize: '13px', color: '#2D87F0', textDecoration: 'none' }}>
                  Already have an account? Log in
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
